import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useArcheAdmin } from '@/auth/hooks/useArcheAdmin';
import { CraftingLandingPage } from './CraftingLandingPage';
import { RecipeListPage } from './RecipeListPage';
import { RecipeDetailPage } from './RecipeDetailPage';
import { RecipeCreatePage } from './RecipeCreatePage';
import { LearnedRecipesPage } from './LearnedRecipesPage';
import { CraftingLogPage } from './CraftingLogPage';

/**
 * Arche wrapper for Crafting — provides ArcheLayout with sidebar
 * and handles sub-routing.
 *
 * Crafting is the recipe-and-crafting system behind LitCraft games, not a
 * user-facing app. End users land on a "nothing to see here" screen; the recipe
 * management surface lives behind the admin-only `/admin/*` routes.
 */
export function CraftingArchePage() {
  // Server route gate: `requireAdminOrLitcraftAdmin` (docs/api-admin.md).
  const isAdmin = useArcheAdmin('litcraft_admin');

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<CraftingLandingPage />} />
        {isAdmin ? (
          <>
            <Route path="/admin" element={<RecipeListPage />} />
            <Route path="/admin/recipes/new" element={<RecipeCreatePage />} />
            <Route path="/admin/recipes/:recipeId" element={<RecipeDetailPage />} />
            <Route path="/admin/learned" element={<LearnedRecipesPage />} />
            <Route path="/admin/log" element={<CraftingLogPage />} />
          </>
        ) : (
          <Route path="/admin/*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </ArcheLayout>
  );
}
